import { motion } from "framer-motion";
import CountUp from "./CountUp";
import { useLang } from "../lib/i18n";

export default function StatsBar() {
  const { t } = useLang();
  const stats = [
    { render: <CountUp to={100} suffix="+" />, label: t.statsLabels[0] },
    { render: <CountUp to={2} />, label: t.statsLabels[1] },
    { render: <span>{t.sameDay}</span>, label: t.statsLabels[2] },
  ];
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-24" data-testid="stats-bar">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="rounded-[2rem] bg-espresso border border-cream/5 shadow-[0_30px_80px_rgba(0,0,0,0.35)] grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-cream/10"
      >
        {stats.map((s, i) => (
          <div key={i} className="px-8 py-10 text-center">
            <div className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-brasslight">
              {s.render}
            </div>
            <div className="mt-2 text-sm font-semibold text-taupe">{s.label}</div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
